import type {RefObject} from 'react';
import {useLayoutEffect, useState} from 'react';

/**
 * Whether a line-clamped element is actually cutting its text off. Measured while clamped only —
 * once expanded the two heights always agree.
 */
export const useIsTextTruncated = (elementRef: RefObject<HTMLElement | null>, text: string, isExpanded: boolean): boolean => {
  const [isTruncated, setIsTruncated] = useState<boolean>(false);

  useLayoutEffect(() => {
    const element = elementRef.current;
    if (element === null || isExpanded) {
      return;
    }

    setIsTruncated(element.scrollHeight > element.clientHeight);
  }, [elementRef, text, isExpanded]);

  return isTruncated;
};
